import React, { useState, useRef, useEffect, Suspense, useMemo } from "react";
import faqclasses from "./FAQs.module.css";
import api from "../../../../../../api";
import DiffModal from "./DiffModal";
import { Dropdown } from "semantic-ui-react";
import UserGuideModal from "./UserGuideModal";
import { useVapiVariables } from "../../../../../../hooks/useVapiVariables";
import vapiVariableService from "../../../../../../services/vapiVariableService";
// add css file for variables
import "./DataConnect/ConversationGoal.css";

export default function ConversationGoal(props) {
  const [promptInput, setPromptInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [oldGoal, setOldGoal] = useState("");
  const [newGoal, setNewGoal] = useState("");
  const textareaRef = useRef(null);
  const {
    variables: availableVariables,
    loading: variablesLoading,
    userTimezone: userTimezone,
  } = useVapiVariables("context,lookup", props?.user_id);
  const [timezones, setTimezones] = useState([]);
  const [timezone, setTimezone] = useState("");
  const [userGuideOpen, setuserGuideOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleConversationGoal = (event) => {
    props.setValue(event.target.value, "conversationGoal");
  };
  useEffect(() => {
    gtUserProf();
  }, []);

  const gtUserProf = () => {
    api.botbuilder
      .getUserTimezone({ user_id: btoa(props.user_id) })
      .then((res) => {
        console.log("res timezone", res);
        setTimezones(res.timezones);
        setTimezone(res.data.user_timezone);
      });
  };

  const handleConfirm = (finalPrompt) => {
    props.setValue(finalPrompt, "conversationGoal");
    setPromptInput("");
    setShowModal(false);
  };
  const handlePromptSubmit = () => {
    if (!promptInput.trim()) return;

    setLoading(true);
    api.botbuilder
      .generateGoal({
        prompt: promptInput,
        conversation_goal: props.conversationData,
      })
      .then((res) => {
        if (res?.status && res?.data?.generated_goal) {
          setOldGoal(props.conversationData);
          setNewGoal(res.data.generated_goal);
          setShowModal(true);
        } else {
          props.setErrorMessage(
            "Oops! Something went wrong while generating your conversation goal. Please try again in a moment."
          );
        }
      })
      .catch((err) => {
        props.setErrorMessage(
          "Oops! Something went wrong while generating your conversation goal. Please try again in a moment."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleTimeZoneSelect = (e, { value }) => {
    setTimezone(value);
    //save timezone to database
    api.botbuilder
      .saveUserTimezone({ user_id: btoa(props.user_id), timezone: value })
      .then((res) => {
        //show success message
        setSuccessMessage("Timezone saved successfully");
        setTimeout(() => {
          setSuccessMessage("");
        }, 4000);
      })
      .catch((err) => {
        setErrorMessage("Error saving timezone");
        setTimeout(() => {
          setErrorMessage("");
        }, 4000);
      });
  };
  const timeZoneOption = useMemo(() => {
    console.log("timezones", timezones);
    let list = Object.keys(timezones).map((key, index) => {
      return {
        key: index,
        text: timezones[key],
        value: key,
      };
    });
    return list;
  }, [timezones]);
  const openUserGuideModal = () => {
    setuserGuideOpen(true);
  };
  const closeUserGuide = () => {
    setuserGuideOpen(false);
  };

  return (
    <>
      {showModal && (
        <DiffModal
          show={showModal}
          oldValue={oldGoal}
          newValue={newGoal}
          onCancel={() => setShowModal(false)}
          onConfirm={handleConfirm}
          title={`Compare Current vs Improved Goal`}
        />
      )}
      <div className="row">
        <div className="col-md-6">
          <div className="box-title">
            This is overview and overall goal of the conversation flow:
          </div>
        </div>
        {props.workspace_version === "v2" && (
          <div className="col-md-6">
            <div className="box-title">
              Make a suggestion to improve your conversation goal:
            </div>
          </div>
        )}
      </div>
      <div className="row">
        <div
          className={props.workspace_version === "v2" ? "col-md-6" : "col-md-8"}
        >
          <textarea
            ref={textareaRef}
            className={`${faqclasses.conversationText}`}
            onChange={handleConversationGoal}
            value={props.conversationData}
          />
          {/* Variables for conversation goal with current time and date */}
        </div>

        {/* Only show prompt section for version v2 */}
        {props.workspace_version === "v2" && (
          <div className="col-md-6">
            <textarea
              placeholder="Enter a prompt to auto-generate goal..."
              className={`${faqclasses.promptText}`}
              value={promptInput}
              onChange={(e) => setPromptInput(e.target.value)}
            />
            {loading && <div className="ui loading form"></div>}

            <button
              type="submit"
              onClick={handlePromptSubmit}
              className="btn linear-gradient yr-submitbtn"
            >
              Submit
            </button>
          </div>
        )}
        <div className="col-md-12">
          {props.bot_type === "Voice_Turbo" && (
            <div
              style={{ marginTop: "10px", marginBottom: "10px" }}
              id="congoal-div"
            >
              <div style={{ marginTop: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    marginBottom: "15px",
                  }}
                >
                  <div
                    className="box-titlebox-title"
                    style={{ fontWeight: "bold", minWidth: "120px" }}
                  >
                    Insert Variables:
                  </div>

                  <select
                    className="form-control"
                    style={{ width: "250px", height: "45px", zIndex: "997787" }}
                    defaultValue=""
                    onChange={(e) => {
                      if (e.target.value) {
                        const variable = e.target.value;
                        if (textareaRef && textareaRef.current) {
                          const textarea = textareaRef.current;
                          const start = textarea.selectionStart;
                          const end = textarea.selectionEnd;
                          const text = textarea.value;
                          const before = text.substring(0, start);
                          const after = text.substring(end, text.length);
                          const newText =
                            before + " {{" + variable + "}} " + after;
                          props.handleConversationGoalChange
                            ? props.handleConversationGoalChange(newText)
                            : (textarea.value = newText);
                          props.setValue(newText, "conversationGoal");
                          setTimeout(() => {
                            textarea.focus();
                            textarea.selectionEnd = start + variable.length + 6;
                          }, 0);
                        }
                        e.target.value = "";
                      }
                    }}
                  >
                    <option value="" disabled>
                      Select Variable To Insert
                    </option>
                    {availableVariables.map((variable, index) => (
                      <option
                        key={index}
                        value={variable.key || variable.value}
                      >
                        {variable.label || variable.name || variable.text}
                      </option>
                    ))}
                  </select>

                  <button
                    type="button"
                    className="btn linear-gradient yr-submitbtn"
                    style={{
                      cursor: "pointer",
                      fontSize: "16px",
                      padding: "10px 20px",
                      height: "45px",
                    }}
                    onClick={openUserGuideModal}
                    id="userguidemodalbtn"
                    title="Variables Guide"
                  >
                    Variables Guide
                  </button>
                </div>
              </div>

              {timezones && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "15px",
                  }}
                >
                  <div
                    className="box-titlebox-title"
                    id="congoal"
                    style={{ fontWeight: "bold", minWidth: "120px" }}
                  >
                    Select Time Zone:
                  </div>
                  <Suspense fallback={<div>Loading...</div>}>
                    <div style={{ marginLeft: "10px" }}>
                      <Dropdown
                        placeholder="Select Time Zone"
                        search
                        selection
                        options={timeZoneOption}
                        value={timezone}
                        name="timezone"
                        onChange={handleTimeZoneSelect}
                        scrolling={true}
                        clearable
                        style={{
                          height: "45px",
                          width: "250px",
                          zIndex: "997917",
                          marginLeft: "6px"
                        }}
                      />
                      {successMessage && (
                        <div
                          className="text-success"
                          style={{
                            marginTop: "10px",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          {successMessage}
                        </div>
                      )}
                      {errorMessage && (
                        <div
                          className="text-danger"
                          style={{
                            marginTop: "10px",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          {errorMessage}
                        </div>
                      )}
                    </div>
                  </Suspense>
                </div>
              )}

              <div
                style={{ fontSize: "12px", color: "#888", marginTop: "10px" }}
              >
                <p style={{ marginBottom: "0px", fontWeight: "600" }}>
                  <strong style={{ fontWeight: "600" }} className="text-info">
                    Note:
                  </strong>{" "}
                  You can trigger variable lookups from external systems before a call connects. To set this up, go to the “Integrations” module and connect your external system. All variables lookups use the caller’s “from” number.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
      <UserGuideModal
        open={userGuideOpen}
        onClose={closeUserGuide}
        showModal={userGuideOpen}
        type="context,lookup"
      />
    </>
  );
}
